// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RobotFilledSvg from "@fishx/icons-svg/es/asn/RobotFilled";
import FishxIcon from '../components/FishxIcon';

var RobotFilled = function RobotFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RobotFilledSvg
  }));
};

RobotFilled.displayName = 'RobotFilled';
export default React.forwardRef(RobotFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RobotFilled.js
// module id = 4032
// module chunks = 0